import LoadScript from '@/utils/loadScript'
import Vue from 'vue'

Vue.use(LoadScript)
